import { ConferenceContext } from '../context/ConferenceProvider'
import React from 'react'
export const useConferenceProvider = () => React.useContext(ConferenceContext)
